import { render, staticRenderFns } from "./MeasureDisclaimer.vue?vue&type=template&id=205fed8a&scoped=true&"
import script from "./MeasureDisclaimer.vue?vue&type=script&lang=js&"
export * from "./MeasureDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./MeasureDisclaimer.scss?vue&type=style&index=0&id=205fed8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205fed8a",
  null
  
)

export default component.exports